import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=d0d77ea0&"
import script from "./UserStats.vue?vue&type=script&lang=ts&"
export * from "./UserStats.vue?vue&type=script&lang=ts&"
import style0 from "./UserStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports